export const isValidSearchInput = (input: string): boolean => {
  return input === '' || input.trim().length > 0
}
